import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { usePrevSalesOrders } from '@/hooks/api/1262_prev_sales_orders';
import { useNextSalesOrders } from '@/hooks/api/1263_next_sales_orders';
import { PrevSalesOrderCreateForm } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/renewed_sales_orders/{components}/PrevSalesOrderCreateForm';
import { PrevSalesOrdersElement } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/renewed_sales_orders/{components}/PrevSalesOrdersElement';
import { NextSalesOrdersElement } from '@/features/w/[identifier]/teams/[team_id]/sales_orders/[sales_order_id]/renewed_sales_orders/{components}/NextSalesOrdersElement';

export const EditRenewedSalesOrders = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`継続プロジェクト（売上）`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `プロジェクト（売上） - ${_t_!.name}`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders` },
        { label: `プロジェクト（売上）詳細`, path: `/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}` },
      ]),
    []
  );

  const { _so_ } = useCurrentSalesOrder();

  return (
    <>
      <WorkspaceLayout>
        <ScrollTop />

        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12 col-lg-9 mx-auto">
              <div className="card mb-4" id="basic-info">
                <div className="card-header d-flex align-items-center">
                  <div className="col-md-8">
                    <h5>継続プロジェクト（売上）</h5>
                  </div>
                </div>
                <div className="card-body pt-0 row">
                  <PrevSalesOrderCreateForm />

                  <NextSalesOrdersElement />

                  <PrevSalesOrdersElement />
                </div>
                <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                  <Link
                    to={`/w/${_w_!.identifier}/teams/${_t_!.id}/sales_orders/${_so_!.id}`}
                    className="btn btn-outline-secondary"
                  >
                    案件詳細へ
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </WorkspaceLayout>
    </>
  );
};
